export default __webpack_public_path__ + "static/media/ViteLogoOnly.e33ece8b.png";